import React from "react";

// BSU math does not use Zendesk like BSU writing
export default function HelpContent() {
    return (
        <div>
            For help, contact{" "}
            <a href="mailto:mathlearningcenter@boisestate.edu">
                mathlearningcenter@boisestate.edu
            </a>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/siteConfig/sites/boisestatemath/siteComponents/helpContent.js